import { createContext } from "react"
import {
    ConfiguracaoFormasDePagamentoModel,
    ConfiguracaoFormasDePagamentoInicial,
} from "../models/configuracaoFormasDePagamentoModel"
import { ConfiguracaoFormasDePagamentoActionModel } from "./configuracaoFormasDePagamentoActions"
import type { SalvarFormasPagamentoResposta } from "../../../services/configuracaoFormasPagamento"

type ConfiguracaoFormasDePagamentoContextProps = {
    dados: ConfiguracaoFormasDePagamentoModel
    dispatch: React.Dispatch<ConfiguracaoFormasDePagamentoActionModel>
    erroCarregamento: string | null
    salvar: () => Promise<SalvarFormasPagamentoResposta | void>
}

const valorInicial: ConfiguracaoFormasDePagamentoContextProps = {
    dados: ConfiguracaoFormasDePagamentoInicial,
    dispatch: () => {},
    erroCarregamento: null,
    salvar: async () => undefined,
}

export const ConfiguracaoFormasDePagamentoContext =
    createContext<ConfiguracaoFormasDePagamentoContextProps>(valorInicial)
